import httpService from './httpService'

const serverPath = window.location.origin
const arsmoApi = '/arsmo_api'
const loginService = {
  wxLogin: (param) => {
    const url = `${serverPath}${arsmoApi}/login`
    return httpService.httpPost(url, param)
  },
  getVerifyCode: (param) => {
    const url = `${serverPath}${arsmoApi}/verify_code`
    return httpService.httpGet(url, param)
  },
  getGraphCode: () => {
    const url = `${serverPath}${arsmoApi}/graph_code`
    return httpService.httpGet(url)
  }
}

export default loginService



// WEBPACK FOOTER //
// ./src/services/login-service.js